import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { hasNoPaidContent } from 'redux/modules/front';
import { getTaboolaConfig, paidContentList } from 'lib/paidContentUtils';
import Ad from 'components/Ad';

import styles from './styles.module.scss';

export const PaidContent = (props) => {
  const [adRendered, setAdRendered] = useState(null);
  const dispatch = useDispatch();

  const {
    adLoaded,
    className,
    isMobileOnlyComponent,
    type,
    vertical,
  } = props;

  const taboolaConfig = getTaboolaConfig({ isMobileOnlyComponent, type, vertical });

  let Element = 'article';
  let adSlot = 'nativethreeup';

  if (type === paidContentList) {
    Element = 'li';
    adSlot = 'nativeultradense';
  }

  useEffect(() => {
    if (adRendered === false) {
      const { mode, container, placement } = taboolaConfig;
      /* eslint-disable no-underscore-dangle */
      window._taboola = window._taboola || [];
      window._taboola.push({
        mode,
        container,
        placement,
        target_type: 'mix',
      });
      /* eslint-enable no-underscore-dangle */
    }
  }, [adRendered]);

  const adHandler = (enigmaAd, { EVENTS }) => {
    enigmaAd.on(EVENTS.RENDER, (event) => {
      if (!event) {
        return;
      }
      if (event.empty) {
        dispatch(hasNoPaidContent());
      }
      setAdRendered(!event.empty);
      adLoaded(true);
    });
    enigmaAd.render();
  };

  return (
    <Element className={className}>
      <Ad
        activeTab={false}
        adClass={styles.nativeAdContainer}
        handler={adHandler}
        refreshInterval={0}
        slot={adSlot}
      />
      {!adRendered && (
        <div id={taboolaConfig.container} />
      )}
    </Element>
  );
};

PaidContent.propTypes = {
  adLoaded: PropTypes.func,
  className: PropTypes.string,
  isMobileOnlyComponent: PropTypes.bool,
  type: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
};

PaidContent.defaultProps = {
  adLoaded: Function.prototype,
  className: null,
  isMobileOnlyComponent: false,
};
